import { Controller } from "@hotwired/stimulus"

// Change log export modal. The CSV downloads without leaving the page, so the form
// would keep the last filters. Reset them to the defaults whenever the modal closes.
export default class extends Controller {
  connect() {
    this.modalElement = this.element.querySelector(".modal")
    this.resetFiltersBound = () => this.element.reset()
    this.modalElement?.addEventListener("hidden.bs.modal", this.resetFiltersBound)
  }

  disconnect() {
    this.modalElement?.removeEventListener("hidden.bs.modal", this.resetFiltersBound)
  }
}
